import React, {useEffect, useMemo, useState, useCallback, useContext} from 'react';
import Aux from '../../../../hoc/Auxiliary';
import {useTranslation} from "react-i18next";
import formatDate from "../../../Utils/Date/formatDate";
import DateFormated from "../../../Utils/Date/Date";
import TableContainer from "./Table/TableContainer";

import DateFilters, {DEFAULT_DATE, TODAY, TODAY_MINUS_14, TODAY_MINUS_30} from "../Tables/DateFilters";
import Spinner from "../../../UI/Spinner";
import Sorter from "../../../UI/Toolbar/Sorter";
import axios from "../../../../axios-defaults";
import Pagination from "../../../UI/Pagination";

import UserContext from '../../../../context/user-context';
import {userHaveSpecificPermission} from "../../../Utils/UserHelper";
import ModalMxo from "../../../UI/Modal";

import SearchForm from "../../../UI/SearchForm/SearchForm";
import date from "../../../Utils/Date/Date";
import SelectWrapper from "../../../Utils/Input/SelectWrapper";
import Helpbox from "../../../UI/Helpboxes/Helpbox";
import {Link} from "react-router-dom";


const ServiceRequests = (props) => {
    const { user } = useContext(UserContext);
    const { currentPeriod, subAccountCode, subAccountType, isSummary } = props;
    const {t, i18n} = useTranslation();
    const [items, setItems] = useState([]);
    const [sortField, setSortField] = useState('createdon');
    const [sortDirection, setSortDirection] = useState('DESC');
    const [sortTableField, setSortTableField] = useState('createdon');
    const [sortTableDirection, setSortTableDirection] = useState('DESC');
    const [loading, setLoading] = useState(0);
    const [pagination, setPagination] = useState({currentPage: 1, itemsPerPage: 6, totalPages: null});

    const [startDate, setStartDate] = useState(formatDate(new Date(DEFAULT_DATE)));
    const [endDate, setEndDate] = useState(formatDate(new Date(TODAY)));
    const [isSpecific, setIsSpecific] = useState(false);
    const [dateFilterType, setDateFilterType] = useState(((!isSummary) ? 'last_14': null));

    const [originalDatas, setOriginalDatas] = useState([]);
    const [orders, setOrders] = useState([]);

    // TODO: Modal Alert on click termine
    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState(null);


    const getServiceRequests = async() => {
        if (startDate === null || endDate === null) {
            return;
        }
        const currentStartDate = (startDate)?startDate:formatDate(new Date(DEFAULT_DATE));
        const currentEndDate = (endDate)?endDate:formatDate(new Date(TODAY));

        await axios.get(`/dataverse/incidents/getlist?startDate=${currentStartDate}&endDate=${currentEndDate}`)
            .then(response => {
                if (response.data.succeeded) {
                    if (isSummary) {
                        setItems(response.data.data.slice(0, 4))
                    } else {
                        setItems(response.data.data)
                        setOriginalDatas(response.data.data)
                    }
                }
            }).catch(error => {
                console.log('[Requests.js] : Account ajax error in getServiceRequests()', error.message);
            });
    }

    useEffect(async () => {
        setLoading(true)
        await getServiceRequests();
        setLoading(false)
    }, [startDate, endDate]);

    let sorter = null;
    const setSorterRef = element => sorter = element;

    const storeSortedItems = (items) => {
        if (items && items.length) {
            setItems(items);
        }
    }


    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }

    /* START DATEFILTERS FUNCTIONS */
    const dateFilterSetStartDate = (date) => {
        if (date != null) {
            setStartDate(formatDate(new Date(date)));
        }
    }
    const dateFilterSetEndDate = (date) => {
        if(date != null){
            setEndDate(formatDate(new Date(date)));
        }
    }
    const setLast14Days = () => {
        setStartDate(formatDate(new Date(TODAY_MINUS_14)));
        setEndDate(formatDate(new Date(TODAY)));
        setIsSpecific(false);
    }
    const setLast30Days = () => {
        setStartDate(formatDate(new Date(TODAY_MINUS_30)));
        setEndDate(formatDate(new Date(TODAY)));
        setIsSpecific(false);
    }
    const setSpecificDate = () => {
        setStartDate(null);
        setEndDate(null);
        setIsSpecific(true);
    }
    const dateFilterSetDateFilterType = (type) => {
        setDateFilterType(type)
        switch (type) {
            case 'last_14': setLast14Days(); break;
            case 'last_30': setLast30Days(); break;
            case 'specific_date': setSpecificDate(); break;
            default: setLast14Days();
        }
    }
    /* END DATEFILTERS FUNCTIONS */


    const columns = useMemo(
        () => [
            {
                id: 'subject',
                Header: t('requests.table.subject'),
                accessor: (a) => {
                    return {
                        title: a.title,
                        ticketnumber: (a.ticketnumber)? a.ticketnumber : null
                    };
                },
                Cell: (props) => {
                    if (props.value.title)
                        if(isSummary)
                            if (props.value.title.length > 21)
                                return <strong>{props.value.title.substring(0,21)+"..."}</strong>;
                            else
                                return <strong>{props.value.title}</strong>;
                        else
                            return <strong>{props.value.title} {(props.value.ticketnumber)&& '#'+props.value.ticketnumber}</strong>;
                    else
                        return '';
                },
            },
            {
                id: 'account',
                Header: t('requests.table.account'),
                accessor: (a) => {
                    return {
                        name: a.account_name,
                        comptejde: a.account_cr034_comptejde
                    };
                },
                Cell: (props) => {
                    if (props.value.name && props.value.comptejde)
                        if(isSummary) {
                            return <span>{props.value.comptejde}</span>;
                        } else {
                            return (
                                <div>
                                    <strong className='d-block'>{props.value.name}</strong>
                                    <span className='d-block'>#{props.value.comptejde}</span>
                                </div>
                            );
                        }
                    else return '';
                },
            },
            {
                Header: t('requests.table.date'),
                accessor: 'createdon',
                sort: 'desc',
                Cell: (props) => {
                    if (props.value) return <DateFormated date={props.value} withTime={true}/>;
                    else return '';
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1)
                        return 1;
                    else if (a1 > b1)
                        return -1;
                    else
                        return 0;
                }
            },
			{
				Header: t('requests.table.status'),
				accessor: 'statecode',
				Cell: (props) => {
					if ([0,1,2].includes(props.value))
						return  (
							<span className={t(`requests.table.state_code.${String(props.value)}.class`)}>
                                <i className={t(`requests.table.state_code.${String(props.value)}.icon`)}
								   aria-hidden="true">
                                </i>
								{t(`requests.table.state_code.${String(props.value)}.title`)}
                            </span>
						)
					else return '';
				},
			},
        ],
        [t, i18n, items]
    );

    const handleSort = useCallback(sortBy => {
        if (sortBy.length > 0) {
            setSortField(sortBy[0].id);
            setSortDirection(sortBy[0].desc?'DESC':'ASC')
        }
    }, [])

    const setSortByCallback = useMemo(() =>
            [{desc:sortTableDirection==='DESC', id:sortTableField}]
        , [sortTableDirection, sortTableField])

    const onPageChanged = data => {
        const { currentPage, totalPages } = data;
        setPagination({
            ...pagination,
            currentPage: currentPage,
            totalPages: totalPages,
        });
    }

    let dataHtml = '';
    if (loading) {
        dataHtml = <Spinner/>
    } else {

        if (isSummary) {
            dataHtml = (
                <div>
                    {items.length > 0 ?
                        <div>
                            <TableContainer columns={columns}
                                data={items.slice(0, 4)}
                                onSort={handleSort}
                                setSortByCallback={setSortByCallback}
                                initialStateField={sortField}
                                initialStateDirection={sortDirection}
                                isSummary={isSummary}
                            />
                            <div className="text-center mt-2">
                                <Link
                                    to={'/requests'}
                                    className="link link--fs-14 link--accent link--red link--upper">
                                    <strong>
                                        {t("account.summary.requests.link")} &nbsp;&nbsp;
                                        <i className="fas fa-angle-right"></i>
                                    </strong>
                                </Link>
                            </div>
                        </div>
                        :
                        <React.Fragment><br/>
                            <h3 className="headline headline--block headline--margin--0">
                                {t("requests.table.no_requests")}
                            </h3>
                        </React.Fragment>
                    }
                </div>
            )
        } else {
            dataHtml = (
                <div>
                    {items.length > 0 ?
                        <div>
                            <TableContainer columns={columns}
                                data={items}
                                onSort={handleSort}
                                setSortByCallback={setSortByCallback}
                                initialStateField={sortField}
                                initialStateDirection={sortDirection}
                                isSummary={isSummary}
                            />
                        </div>
                        :
                        <React.Fragment><br/>
                            <h3 className="headline headline--block headline--margin--0">
                                {items.length} {t("requests.table.search_results")}
                            </h3>
                        </React.Fragment>
                    }
                </div>
            )
        }
    }


    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const onSearchDataUpdate = (searchData) => {
        if (Array.isArray(searchData)) {
            return setItems(searchData);
        } else {
            return null;
        }
    }

    return (
        <Aux>
            { !isSummary &&
                <div>
					{(user && user.account && user.account.classification.code !== 'COM') ?
                    	<div className="flex align-items-center row section--padding--bottom--30">
							<div className="col-lg-6">
								<Helpbox type='invoice' cta={true} />
							</div>
							{user && user.infos && user.infos.permission !== 'limited' && (
								<div className="col-lg-6">
									<Helpbox type='budget' cta={true} />
								</div>
							)}
						</div> :
						<div className="row section--padding--bottom--30">
							<div className="col-lg-6 offset-lg-6">
								<Helpbox type='invoice' cta={true} />
							</div>
						</div>
						}

                    <div className="section__action section__action--requests">
                        <SearchForm data={originalDatas} updateData={onSearchDataUpdate}/>
                        <a href={t('footer.need_help_link')} className='btn btn--outline'>{t('communications.contactourteam')}</a>
                    </div>
                    <br/>

                    <div className="flex align-items-center row section--padding--bottom--20 filters">
                        <div className="col-lg-6 filters__left">
                            <DateFilters
                                startDate={startDate}
                                endDate={endDate}
                                setStartDate={dateFilterSetStartDate}
                                setEndDate={dateFilterSetEndDate}
                                changeDateFilterType={dateFilterSetDateFilterType}
                                dateFilterType={dateFilterType}
                                component="requests"
                            />
                        </div>
                        <div className="col-lg-6 filters__right">
                            {/*<SelectWrapper>*/}
                            {/*    <select onChange={(e) => {*/}
                            {/*        let selectValue = e.target.value;*/}
                            {/*        this.onFilterChange(selectValue, 'accountType');*/}
                            {/*    }}*/}
                            {/*            value={this.state.filters.accountType}>>*/}
                            {/*        <option value="">{t('misc.account_type')}</option>*/}
                            {/*        {this.state.accountTypes.map(type => {*/}
                            {/*            if (type.code) {*/}
                            {/*                return (<option value={type.code}*/}
                            {/*                                key={type.code}>{this.props.t('misc.account_types.' + type.code)}</option>);*/}
                            {/*            } else {*/}
                            {/*                return '';*/}
                            {/*            }*/}
                            {/*        })}*/}
                            {/*    </select>*/}
                            {/*</SelectWrapper>*/}
                            <Sorter
                                sortOptions={[
                                    {
                                        label: t('requests.table.choose'),
                                        id: 'none',
                                        value: '',
                                    },{
                                        label: t('requests.table.subject'),
                                        id: 'subject',
                                        value: 'subject',
                                        type: 'string'
                                    },{
                                        label: t('requests.table.account'),
                                        id: 'account',
                                        value: 'account',
                                        type: 'string'
                                    },{
                                        label: t('requests.table.date'),
                                        id: 'createdon',
                                        value: 'createdon',
                                        type: 'string'
                                    }, {
                                        label: t('requests.table.status'),
                                        id: 'statecode',
                                        value: 'statecode',
                                        type: 'float'
                                    }
                                ]}
                                items={items}
                                getSortedItems={storeSortedItems}
                                setSortByCallback={setSorterCallback}
                                sortDirection={sortDirection}
                                sortField={sortField}
                                currentDisplayMode='list'
                            />
                        </div>
                    </div>
                </div>
            }
            {dataHtml}
            {/*<ModalMxo title={modalTitle}*/}
            {/*          show={showModal}*/}
            {/*          hideFooter={true}*/}
            {/*          footerActions={null}*/}
            {/*          backDrop={true}*/}
            {/*          onHide={handleCloseModal}*/}
            {/*          onShow={handleShowModal}*/}
            {/*>*/}
            {/*    {modalContent}*/}
            {/*</ModalMxo>*/}
        </Aux>
    );
}

export default ServiceRequests;
